import React from "react";
import { Link } from "react-router-dom";
import usePageMeta from "../usePageMeta";

const EMAIL = "juniahmad.dev@gmail.com";

function Contact() {
  usePageMeta(
    "Contact – Hisaab Tools",
    "Contact Hisaab Tools: email us about a bug, a correction, or an idea for a new calculator."
  );

  return (
    <main className="page">
      <div className="calc-card fade-in">
        <h1>Contact Us</h1>
        <div className="seo-content seo-content-plain">
          <p>
            Hisaab Tools is built and maintained by one person, and feedback
            from people who use the calculators is the main way it improves.
            If something looks wrong, if a result doesn't match what you
            expected, or if there's a calculator you wish existed, please get
            in touch.
          </p>

          <h2>Email</h2>
          <p>
            The best way to reach us is by email at{" "}
            <a href={`mailto:${EMAIL}`}>{EMAIL}</a>. We read every message and
            usually reply within a couple of days.
          </p>

          <h2>What to include</h2>
          <p>
            For a bug or an incorrect result, it helps to mention which
            calculator you were using, the values you entered, the answer you
            got, and the answer you expected. For a new-calculator request, a
            sentence on what it should work out and a quick example is plenty.
          </p>

          <h2>Corrections</h2>
          <p>
            Tax slabs, nisab rules, and formulas can change over time. If you
            spot an out-of-date figure — for example in the{" "}
            <Link to="/pakistan-income-tax">Pakistan income tax calculator</Link>{" "}
            or the <Link to="/zakat">Zakat calculator</Link> — let us know and
            we'll verify and update it. See our{" "}
            <Link to="/privacy-policy">Privacy Policy</Link> for how the site
            handles data.
          </p>
        </div>
      </div>
    </main>
  );
}

export default Contact;
